import React, { useState, useEffect, useRef } from "react";
import "./ExtruderStatus.css"
import { images } from "../../config/images";
import {
    Box,
    Container,
    Typography,
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import { getPlants } from "../Dashboard/services";
import { getExtruderStatus, updateExtruderSize } from "./services";
import { getSizesExtruder } from "../Dashboard/services";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { userFootFallTracking } from "../FootFallReport/services";

const ExtruderStatus = () => {

    const navigate = useNavigate();

    const [selectedPlants, setSelectedPlants] = useState();
    const [extruderData, setExtruderData] = useState([]);
    const [currentPlantId, setCurrentPlantId] = useState(""); // Selected plant ID
    const [selectedSize, setSelectedSize] = useState([]);
    const [groupedExtruderData, setGroupedExtruderData] = useState();
    const [updatedExtruderData, setUpdatedExtruderData] = useState([]);
  const {  is_normal_user } = useSelector(
    (state) => state.userState
  );

    // asynchronous function to fetch production data API
    const getData = async () => {
        try {
            const resp = await getPlants();
            setSelectedPlants(resp.data.payload);
            if (resp.data.success == true) {
            }
            setCurrentPlantId(resp.data.payload[0]?.id); // Default to the first plant

            const resp1 = await getSizesExtruder(resp.data.payload[0]?.id);
            setSelectedSize(resp1.data.payload);
        } catch (error) {
            console.log(error);
        }
    };


    useEffect(() => {
        getData();
        return () => { };
    }, []);
    const handlePlantChange = (e) => {
        const newPlantId = e.target.value;
        setCurrentPlantId(newPlantId);
    }
    useEffect(() => {
        if (currentPlantId) {
            fetchExtruderStatus(currentPlantId);
        }
        // Set up the interval
        const intervalId = setInterval(() => {
            fetchExtruderStatus(currentPlantId);
        }, 5000); // Call every 5 sec

        // Cleanup interval on unmount
        return () => {
            clearInterval(intervalId);
        };
    }, [currentPlantId])

    const fetchExtruderStatus = async (id) => {
        try {
            const response = await getExtruderStatus(id);
            setExtruderData(response.data.payload);

        } catch (error) {
            console.error("Error fetching extruder status:", error);
        }
    };
      useEffect(() => {
        let intervalId = null;
    
        const callUserFootFallTracking = () => {
          const moduleList = JSON.parse(localStorage.getItem("moduleList"));
          if (moduleList) {
            const module = moduleList.find((m) => m.name === "Extruder Status");
            if (module) {
              const params = { module_id: module.id };
              try {
                userFootFallTracking(params);
              } catch (error) {
                console.error("Error calling userFootFallTracking:", error);
              }
            }
          }
        };
    
        const startTracking = () => {
          if (!intervalId) {
            console.log("▶️ Start API interval");
            callUserFootFallTracking(); // call immediately
            intervalId = setInterval(callUserFootFallTracking, 5 * 60 * 1000);
          }
        };
    
        const stopTracking = () => {
          if (intervalId) {
            console.log("⏹ Stop API interval");
            clearInterval(intervalId);
            intervalId = null;
          }
        };
    
        const handleVisibilityChange = () => {
          if (document.hidden) {
            stopTracking(); // stop when tab hidden/minimized
          } else {
            startTracking(); // resume when tab active
          }
        };
    
        // Setup listener
        document.addEventListener("visibilitychange", handleVisibilityChange);
    
        // Start tracking immediately if tab is visible
        if (!document.hidden) {
          startTracking();
        }
    
        return () => {
          stopTracking();
          document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
      }, []);
    const handleSelectSize = async (extruderId, sizeId) => {
        if(!is_normal_user){
            try {
                const params = {
                    extruder_status_id: extruderId,
                    size_id: sizeId
                }
                const response = await updateExtruderSize(params);
                if (response.data.success == true) {
                    const updatedExtruder = response.data.payload; // Response from the API
                    setUpdatedExtruderData((prevData) => {
                        const index = prevData.findIndex((line) => line.id === updatedExtruder.id);
                        if (index !== -1) {
                            prevData[index] = updatedExtruder;
                            return [...prevData];
                        } else {
                            return [...prevData, updatedExtruder];
                        }
                    });
                }
    
            } catch (error) {
    
            }
        }
        else{
            toast.error("You don't have access")
        }
     
    };

    const groupDataByExtruder = (data) => {
        const grouped = data.reduce((acc, item) => {
            if (!acc[item.extruder_name]) {
                acc[item.extruder_name] = [];
            }
            acc[item.extruder_name].push(item);
            return acc;
        }, {});
        return grouped;
    };
    useEffect(() => {
        setGroupedExtruderData(groupDataByExtruder(extruderData));

    }, [extruderData]);

    return (
        <>
            <div className="containerWrap">
                <ToastContainer />
                <Container maxWidth="xxl">
                    <div className="extruderStatusHeader-wrap">
                        <div className="extruderStatusTitle-wrap">
                            <KeyboardBackspaceIcon
                                onClick={() => navigate("/dashboard")}
                                className="backArrow"
                            />
                            <Typography
                                variant="h5"
                                className="extruderStatusTitle"
                                gutterBottom
                                onClick={() => navigate("/dashboard")}
                            >
                                Extruder Status
                            </Typography>
                        </div>
                        <div>
                            <Box style={{ width: "190px", marginBottom: "0" }}>
                                <select
                                    className="form-input-class"
                                    id="selectedClass"
                                    value={currentPlantId}
                                    onChange={(e) =>
                                        handlePlantChange(e)
                                    }
                                    required
                                >
                                    {selectedPlants ? (
                                        selectedPlants.map((event) => (
                                            <option value={event.id}>{event.name}</option>
                                        ))
                                    ) : (
                                        <option>{"No Data Found"}</option>
                                    )}
                                    {/* <option value="alsantejl"> Santej </option>
                                                <option value="dhalka"> Dhalka </option>
                                                <option value="hosur"> Hosur </option>
                                                <option value="cuttack"> Cuttack </option> */}
                                </select>
                            </Box>
                        </div>
                    </div>
                    <div className="extruderStatusList-wrap">
                        {groupedExtruderData &&
                            Object.entries(groupedExtruderData).map(([extruderName, lines]) => {
                                // Determine label printer status
                                const labelPrinter = lines.some((line) => line.printer_status)
                                    ? "Alarm"
                                    : "Normal";
                                // Merge updatedExtruderData with lines for sorting and display
                                const mergedLines = lines.map((line) => {
                                    const updatedLine = updatedExtruderData.find(
                                        (updated) => updated.id === line.id
                                    );
                                    return updatedLine || line; // Use updated line data if available
                                });

                                // Sort lines after merging updated data
                                const sortedLines = mergedLines.sort((a, b) => a.line - b.line);

                                return (
                                    <div key={extruderName} className="extruder-card">
                                        <Typography variant="h6" className="extruder-title">
                                            {extruderName}
                                        </Typography>
                                        {sortedLines.map((line) => {
                                            const lineName = `Line ${String(line.line).padStart(2, "0")}`;
                                            const statuses = [
                                                !line.iiot_system ? "Normal" : "Alarm",
                                                !line.uid_alert ? "Normal" : "Alarm",
                                                !line.nij_communication ? "Normal" : "Alarm",
                                                !line.cij_communication ? "Normal" : "Alarm",
                                                !line.emergency_switch ? "Normal" : "Alarm",
                                            ];

                                            return (
                                                <div key={line.id} className="line-card">
                                                    <div className="line-header">
                                                        <Typography
                                                            variant="subtitle1"
                                                            className="line-title"
                                                        >
                                                            {lineName}
                                                        </Typography>
                                                        <select
                                                            className="line-select"
                                                            onChange={(e) =>
                                                                handleSelectSize(line.id, e.target.value)
                                                            }
                                                            value={line.size || ""} // Reflect updated size or fallback to original
                                                        >
                                                            <option value="" disabled={!line.size}>
                                                                Select Size
                                                            </option>
                                                            {selectedSize.length > 0 &&
                                                                selectedSize.map((sizeObj) => (
                                                                    <option
                                                                        key={sizeObj.id}
                                                                        value={sizeObj.id}
                                                                    >
                                                                        {sizeObj.size}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </div>
                                                    <ul className="status-list">
                                                        {statuses.map((status, index) => (
                                                            <li
                                                                key={index}
                                                                className={`status-item ${status.toLowerCase()}`}
                                                            >
                                                                {[
                                                                    "IoT System",
                                                                    "UID Alert",
                                                                    "NIJ Communication",
                                                                    "CIJ Communication",
                                                                    "Emergency Switch",
                                                                ][index]}
                                                                <span
                                                                    className={`status-tag ${status.toLowerCase()}`}
                                                                >
                                                                    {status}
                                                                </span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            );
                                        })}
                                        {!extruderName.startsWith("Offline") && (
                                            <div className="label-printer-status">
                                                <span className="label-printer-status-title">
                                                    Label Printer Status
                                                </span>
                                                <span
                                                    className={`status-tag ${labelPrinter.toLowerCase()}`}
                                                >
                                                    {labelPrinter}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                    </div>




                </Container>

            </div>
        </>
    )
}

export default ExtruderStatus;
